module.exports = __webpack_public_path__ + "img/1ee48c4dd09fda3a1a10faef4eb42a0f.56131e3d.jpg";